// extracted by css-extract-rspack-plugin
export default {"Column":"Xzt8PvJZYI5qgfCf","ColumnInner":"XYrqWrNHB1IfgX_7","IsNumbered":"Khzq1S2QTVsSFuji","ColumnResizer":"KggDJJfGRt4WYf3j","slim":"XFVLDlW8w1EjifKt"};